// Runtime page title / description / robots. Crawlers that don't run JS
// (WhatsApp, Facebook link previews) only ever see the generic defaults in
// public/index.html — per-link og tags need a hosting rewrite/function.

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function setPageMeta({ title, description, noindex }) {
  const fullTitle = title ? `${title} | Tapes To Digital` : "Tapes To Digital";
  document.title = fullTitle;
  setMeta("property", "og:title", fullTitle);
  if (description) {
    setMeta("name", "description", description);
    setMeta("property", "og:description", description);
  }
  // public/index.html ships noindex for the whole order subdomain (the
  // website is what gets indexed); personal pages set it again explicitly
  if (noindex) setMeta("name", "robots", "noindex, nofollow");
}
